export const INTEGRATIONS_BASE_URL = process.env.REACT_APP_INTEGRATIONS_API_BASE_URL;
export const INTERNAL_BASE_URL = process.env.REACT_APP_INTERNAL_API_BASE_URL;
export const ESIGN_DEV_MODE = !!parseInt(process.env.REACT_APP_ESIGN_DEV_MODE, 2);
export const DEFAULT_TOKEN_NAME = 'access_token';
export const MAX_UPLOAD_SIZE_IN_BYTES = 40000000;
export const MAX_EMPLOYEE_DOC_UPLOAD_SIZE_IN_BYTES = 800000000;
export const MAX_DOC_CATEGORY_LENGTH = 50;
export const ACCEPTED_FILE_TYPES = 'application/pdf,image/*,.doc,.docx';
export const APPLICATION_ROOT = '#asure-react-app';
export const IMAGE_TYPES = ['.gif', '.jpg', '.png', '.webp', '.svg', '.ico'];
export const AUTO_GENERATED_FILE_CATEGORIES = ['Onboarding-I9', 'Onboarding-W4', 'Onboarding-Direct Deposit', 'Onboarding-Background Check Auth'];
export const DROPDOWN_SEARCH_DEBOUNCE_TIME = 800;
export const FILTER_TABLE_DEBOUNCE = 200;
export const FETCH_TABLE_SEARCH_DEBOUNCE = 600;
export const SEARCH_EMPLOYEES_DEBOUNCE_TIME = 250;
export const SIMPLE_SIGN_ROUTE = '/simple-sign';
export const HELLO_SIGN_ROUTE = '/sign-document';



// WEBPACK FOOTER //
// ./src/constants/globals.js